import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { Logo } from "./Icons";

/** The top bar shared by every admin screen. */
export function Shell({
  children,
  actions,
  crumb,
}: {
  children: React.ReactNode;
  actions?: React.ReactNode;
  crumb?: React.ReactNode;
}) {
  const { admin, signOut } = useAuth();

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <header
        style={{
          display: "flex",
          alignItems: "center",
          gap: 14,
          padding: "14px 20px",
          background: "var(--surface)",
          borderBottom: "0.5px solid var(--outline)",
          flexWrap: "wrap",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <Link
          to="/admin"
          style={{ display: "flex", alignItems: "center", gap: 10, color: "inherit" }}
        >
          <Logo size={26} />
          <span style={{ fontSize: 19, fontWeight: 700, letterSpacing: "-0.4px" }}>Ripple</span>
        </Link>
        {crumb}
        <div style={{ flex: 1 }} />
        {actions}
        <span className="tiny" style={{ marginLeft: 4 }}>
          {admin?.username}
        </span>
        <button className="btn btn-text" onClick={() => void signOut()}>
          Sign out
        </button>
      </header>
      <main style={{ flex: 1, minHeight: 0 }}>{children}</main>
    </div>
  );
}
